import { createFileRoute } from "@tanstack/react-router";

import { MirrorPage } from "@/components/MirrorPage";
import { content } from "@/mirror/page/privacy-website";
import { requireUnlockedHome } from "@/lib/gate.functions";
import { mirrorHead } from "@/mirror/pages";

export const Route = createFileRoute("/privacy/website")({
  loader: () => requireUnlockedHome(),
  head: () => mirrorHead("privacy-website"),
  component: () => <MirrorPage key="privacy-website" slug="privacy-website" content={content} />,
});
